import { render, staticRenderFns } from "./MissingResourceAlert.vue?vue&type=template&id=11c5b283"
import script from "./MissingResourceAlert.vue?vue&type=script&lang=js"
export * from "./MissingResourceAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports